import { routeChangeEvent } from "~/utils/gtmUtils";
export default defineNuxtPlugin(() => {
  if (process.client) {
    const router = useRouter();

    router.afterEach((to, from) => {
      routeChangeEvent(to.fullPath, from.fullPath);
    });
  }
});
